
const products = [
  {
    id: 1,
    name: "Floral Embroidery",
    price: 1000,
    rating: 4.5,
         category: "lugda",

    image: "/images/emb1.jpeg"
  },
  {
    id: 2,
    name: "Royal Pattern Design",
    price: 1500,
    rating: 4.0,
         category: "lugda",

    image: "/images/emb2.jpeg"
  },
  {
    id: 3,
    name: "Vintage Thread Work",
    price: 1800,
    rating: 5,
         category: "lugda",

    image: "/images/emb3.jpeg"
  },
  {
    id: 4,
    name: "Peacock Design",
    price: 999,
    rating: 4.2,
         category: "lugda",

    image: "/images/emb4.jpeg"
  },
  {
    id: 5,
    name: "Tribal Patch Embroidery",
    price: 849,
    rating: 3.9,
         category: "lugda",

    image: "/images/emb5.jpeg"
  },
  {
    id: 6,
    name: "Contemporary Stitch",
    price: 800,
    rating: 4.9,
         category: "lugda",

    image: "/images/emb6.jpeg"
  },
   {
    id: 7,
    name: " Stitch",
    price: 749,
    rating: 4.2,
     category: "lugda",
    image: "/images/emb7.jpeg"
  },
   {
    id: 8,
    name: "Contemporary ",
    price: 900,
    rating: 4.7,
     category: "lugda",
    image: "/images/lugda2.jpg"
  },
  {
    id: 9,
    name: "Contemporary Stitch2",
    price: 600,
    rating: 4.5,
     category: "lugda",
    image: "/images/lugda.jpg"
  },
  {
    id: 10,
    name: "Contemporary Stitch3",
    price: 1000,
    rating: 4.3,
     category: "lugda",
    image: "/images/mummy.jpeg"
  },
   {
    id: 11,
    name: "Floral Embroidered Kurta",
    price: "₹999",
    category: "kurta",
    image: "https://sojanya.com/cdn/shop/files/B-LUX-LK-Cut-EMB-1081-Black-1_9ee2281a-47b2-4dc8-808f-16e5c01e046e_2048x2048.jpg?v=1744374992",
  },
  {
    id: 12,
    name: "Cotton T-Shirt",
    price: "₹499",
    category: "tshirt",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJR838vrUalkNiPP08ywzSXSKC7mXOnbz-rQ&s",
  },
  {
    id: 13,
    name: "Denim Jeans",
    price: "₹1299",
    category: "jeans",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRpGn0kOabVDrHJ0mLaXKXQfDIriReFakSkUQ&s",
  },
  {
    id: 14,
    name: "Party Wear Skirt",
    price: "₹1099",
    category: "skirt",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSO6TRfW9RW0goBHYlU4k5WQgRxxOLZ0-H9pQ&s",
  },
  {
    id: 15,
    name: " womens kurta",
    price: "₹1099",
    category: "kurta",
    image: "https://www.angadcreations.com/wp-content/uploads/2023/09/IMG_0957_result.webp",
  },
  {
    id: 16,
    name: " Traditional Ethnic skirt",
    price: "₹1099",
    category: "skirt",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSS9raz0RIhEq0j807_dpF9s7DxF_hc2V9DiQ&s",
},
{
    id: 17,
    name: "Denim Jeans",
    price: "₹1299",
    category: "jeans",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQOImRlCuMbK1-UGRWAQ4KNXy9ZY32V8hzqQ&s",
  },
  {
    id: 18,
    name: "Cotton T-Shirt",
    price: "₹499",
    category: "tshirt",
image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRHQpPjhagmoW-XEB2be3IRyf0BFmcKncKdEQ&s"  },
];

export default products